<div class="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8 w-full max-w-lg relative">
    
    <!-- Close Button -->
    <button mat-dialog-close class="absolute top-4 right-4 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 transition-colors">
        <mat-icon svgIcon="tabler_outline:x"></mat-icon>
    </button>
    
    <h2 class="text-2xl font-bold text-center text-gray-800 dark:text-gray-100 mb-6">Select or create project</h2>

    <!-- Options Container -->
    <div class="space-y-4">
        
        <!-- Option 1: Choose Existing Project -->
        <div class="border-2 border-gray-200 dark:border-gray-700 rounded-lg p-6 flex flex-col space-y-4">
            <div class="flex items-center space-x-6">
                <mat-icon svgIcon="tabler_outline:folder" class="text-blue-500 w-10 h-10 flex-shrink-0"></mat-icon>
                <div>
                    <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Choose an Existing Project</h3>
                    <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">Attach to a project you've already created.</p>
                </div>
            </div>
            
            <!-- Search Input -->
            <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Search project</mat-label>
                <mat-icon matPrefix svgIcon="tabler_outline:search" class="mr-2"></mat-icon>
                <input matInput [formControl]="searchCtrl">
            </mat-form-field>

            <!-- Scrollable Project List -->
            <div class="max-h-48 overflow-y-auto space-y-2 pr-2 -mr-2 relative min-h-[5rem]">
                <!-- Loader -->
                <div *ngIf="isLoading" class="absolute inset-0 flex items-center justify-center bg-white dark:bg-gray-800 bg-opacity-75 dark:bg-opacity-75 z-10 rounded-md">
                    <mat-spinner diameter="40"></mat-spinner>
                </div>

                <!-- Project List -->
                <ng-container *ngIf="(filteredProjects$ | async) as projects">
                    <div *ngFor="let project of projects" 
                         (click)="selectProject(project._id)"
                         class="p-3 rounded-md cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                        <p class="font-medium text-gray-800 dark:text-gray-200 truncate">{{ project.name }}</p>
                        <p class="text-xs text-gray-500 dark:text-gray-400">{{ project.address.street }}, {{ project.address.city }}</p>
                    </div>

                    <!-- Empty State -->
                    <div *ngIf="projects.length === 0 && !isLoading" class="flex flex-col items-center justify-center text-center text-gray-400 dark:text-gray-500 h-full min-h-[5rem]">
                        <mat-icon svgIcon="tabler_outline:folder-off" class="w-8 h-8"></mat-icon>
                        <p class="text-sm mt-2">No projects found.</p>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- OR Separator -->
        <div class="flex items-center">
            <div class="flex-grow border-t border-gray-200 dark:border-gray-700"></div>
            <span class="flex-shrink mx-4 text-gray-400 dark:text-gray-500 text-sm font-semibold">OR</span>
            <div class="flex-grow border-t border-gray-200 dark:border-gray-700"></div>
        </div>

        <!-- Option 2: Create New Project -->
        <div class="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg p-6 text-center hover:border-primary-500 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-all cursor-pointer"
             (click)="createNewProject()">
            <div class="flex flex-col items-center justify-center">
                <mat-icon svgIcon="tabler_outline:folder-plus" class="text-primary-500 w-10 h-10"></mat-icon>
                <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100 mt-3">Create a New Project</h3>
                <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">Start fresh with a new project and location.</p>
            </div>
        </div>
    </div>
</div>